/* COMS motion — vanilla JS, no dependencies.
   Re-initialises when sections are added/changed in the theme editor. */
(function () {
  'use strict';
  if (window.COMS_MOTION) return; // already loaded by another section on this page

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var touch = window.matchMedia('(hover: none)');
  var mobile = window.matchMedia('(max-width: 749px)');
  window.COMS_MOTION = true; // tells the inline head snippet the script loaded
  document.documentElement.classList.add('coms-js');

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' })
    : null;

  function watch(el) {
    if (io && !reduce.matches) io.observe(el);
    else el.classList.add('is-in');
  }

  function initKinetic(el) {
    if (el.dataset.comsDone) return;
    el.dataset.comsDone = '1';
    var words = el.textContent.trim().split(/\s+/);
    el.setAttribute('aria-label', el.textContent.trim());
    el.innerHTML = words.map(function (w, i) {
      return '<span class="coms-word" aria-hidden="true"><span style="--coms-i:' + i + '">' +
        w.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }) +
        '</span></span>';
    }).join(' ');
    watch(el);
  }

  function initStagger(el) {
    Array.prototype.forEach.call(el.children, function (child, i) {
      child.style.setProperty('--coms-i', i);
    });
    watch(el);
  }

  function initMarquee(el) {
    if (el.dataset.comsDone) return;
    el.dataset.comsDone = '1';
    var track = document.createElement('div');
    track.className = 'coms-marquee-track';
    track.innerHTML = el.innerHTML + el.innerHTML; // doubled for a seamless loop
    track.lastElementChild && Array.prototype.slice.call(track.children, track.children.length / 2)
      .forEach(function (c) { c.setAttribute('aria-hidden', 'true'); });
    el.innerHTML = '';
    el.appendChild(track);
  }

  function initMagnetic(el) {
    if (touch.matches || reduce.matches || el.dataset.comsDone) return;
    el.dataset.comsDone = '1';
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left - r.width / 2) * 0.25;
      var y = (e.clientY - r.top - r.height / 2) * 0.35;
      el.style.transform = 'translate(' + x + 'px,' + y + 'px)';
    });
    el.addEventListener('pointerleave', function () { el.style.transform = ''; });
  }

  function initTilt(el) {
    if (touch.matches || reduce.matches || el.dataset.comsDone) return;
    el.dataset.comsDone = '1';
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      el.style.transform = 'perspective(800px) rotateY(' + px * 8 + 'deg) rotateX(' + -py * 8 + 'deg)';
    });
    el.addEventListener('pointerleave', function () { el.style.transform = ''; });
  }

  function initCount(el) {
    if (el.dataset.comsDone) return;
    el.dataset.comsDone = '1';
    var target = parseFloat(el.getAttribute('data-coms-count')) || 0;
    var suffix = el.getAttribute('data-coms-count-suffix') || '';
    function finish() { el.textContent = target.toLocaleString() + suffix; }
    if (reduce.matches || !('IntersectionObserver' in window)) return finish();
    var obs = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      obs.disconnect();
      var start = performance.now();
      (function tick(now) {
        var p = Math.min((now - start) / 1200, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased).toLocaleString() + suffix;
        if (p < 1) requestAnimationFrame(tick);
      })(start);
    }, { threshold: 0.5 });
    obs.observe(el);
  }

  // Scroll-linked effects share one rAF loop.
  var scrollEls = [];
  var ticking = false;
  function updateScroll() {
    ticking = false;
    var vh = window.innerHeight;
    scrollEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var progress = (vh - r.top) / (vh + r.height); // 0 → 1 across the viewport
      if (el.hasAttribute('data-coms-spin')) {
        var speed = parseFloat(el.getAttribute('data-coms-spin-speed')) || 0.4;
        if (mobile.matches) speed /= 2;
        el.style.transform = 'rotate(' + (progress * 360 * speed).toFixed(2) + 'deg)';
      } else if (el.hasAttribute('data-coms-parallax')) {
        if (mobile.matches) { el.style.transform = ''; return; }
        var s = parseFloat(el.getAttribute('data-coms-parallax-speed')) || 0.15;
        el.style.transform = 'translate3d(0,' + ((progress - 0.5) * vh * s).toFixed(1) + 'px,0)';
      }
    });
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(updateScroll); }
  }

  function initStickyAtc(scope) {
    scope.querySelectorAll('.coms-sticky-atc').forEach(function (bar) {
      if (bar.dataset.comsDone) return;
      bar.dataset.comsDone = '1';
      var targetSel = bar.getAttribute('data-watch');
      var target = targetSel && document.querySelector(targetSel);
      if (!target || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }).observe(target);
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-coms-kinetic]').forEach(initKinetic);
    scope.querySelectorAll('[data-coms-reveal]').forEach(watch);
    scope.querySelectorAll('[data-coms-stagger]').forEach(initStagger);
    scope.querySelectorAll('[data-coms-marquee]').forEach(initMarquee);
    scope.querySelectorAll('[data-coms-magnetic]').forEach(initMagnetic);
    scope.querySelectorAll('[data-coms-tilt]').forEach(initTilt);
    scope.querySelectorAll('[data-coms-count]').forEach(initCount);
    initStickyAtc(scope);
    if (!reduce.matches) {
      scope.querySelectorAll('[data-coms-spin],[data-coms-parallax]').forEach(function (el) {
        if (scrollEls.indexOf(el) === -1) scrollEls.push(el);
      });
      updateScroll();
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
